import { JOURNEY_TYPE_V2 } from 'lib/flights'
import { Models as FlightModels } from '@luxuryescapes/lib-flights-types'

export function onewayFareMap(onewayFare: any): App.OnewayFare {
  return {
    arrivalAirport: onewayFare.arrivalAirport,
    arrivalCountry: onewayFare.arrivalCountry,
    arrivalCity: onewayFare.arrivalCity,
    departureAirport: onewayFare.departureAirport,
    departureCountry: onewayFare.departureCountry,
    departureCity: onewayFare.departureCity,
    fares: onewayFare.fares.filter(fare => fare !== null).map(journeyV2Map),
  }
}

export function journeyV2Map(fare: FlightModels.Search.Fare): App.JourneyV2 {
  return {
    id: fare.id,
    provider: fare.provider,
    name: fare.name,
    fareBasisCode: fare.fareBasisCode,
    fareType: fare.fareType,
    carrier: fare.carrier,
    carrierName: fare.carrierName,
    carrierLogo: fare.carrierLogo,
    displayName: fare.displayName,
    cabin: fare.cabin ?? '',
    bookingInfo: fare.bookingInfo,
    pairedFareId: fare.pairedFareId,
    price: fare.price,
    flightGroups: fare.flightGroups,
    currencyCode: fare.currencyCode,
    currencySymbol: fare.currencySymbol,
    isInboundCarrierSameFilter: fare.isInboundCarrierSameFilter,
    itemType: JOURNEY_TYPE_V2,
    links: fare.links,
  }
}
